type ToastType = "success" | "error" | "warning" | "info"

export function toast(message: string, type: ToastType = "info") {
  window.dispatchEvent(
    new CustomEvent("toast:show", { detail: { message, type } })
  )
}

toast.success = (message: string) => toast(message, "success")
toast.error = (message: string) => toast(message, "error")
toast.warning = (message: string) => toast(message, "warning")
toast.info = (message: string) => toast(message, "info")
